import { currentUserSelector } from "components/login/logic/actions";
import { filterCurrentUsers, filterKey, transformUsers } from "components/settings/user/common";
import { createError } from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import { assertString } from "core/validation";
import * as log from "loglevel";
import { call, debounce, put, select, takeLatest } from "redux-saga/effects";
import UserService from "services/userService";
import { actions, listSelector, queryParamSelector, searchQSelector } from "./actions";

export function* loadList() {
    try {
        const params = yield select(queryParamSelector);
        const usersData = yield call(UserService.filterUsers, params);
        const currentUser = yield select(currentUserSelector);
        const users = transformUsers(usersData, currentUser);
        yield put(actions.LOAD_LIST.success({ users }));
        yield call(searchQ);
    } catch (e) {
        log.error(e);
        yield put(actions.LOAD_LIST.failed(createError(e)));
    }
}
export function* searchQ() {
    try {
        const searchQ = yield select(searchQSelector);
        const list = yield select(listSelector);
        if (!assertString(searchQ)) {
            yield put(actions.ON_SEARCH.success(list));
        }
        else {
            const filterList = filterCurrentUsers(list).filter((user) => {
                return (
                    filterKey("username", user, searchQ) ||
                    filterKey("lastName", user, searchQ) ||
                    filterKey("fistName", user, searchQ) ||
                    filterKey("email", user, searchQ)
                );
            });

            yield put(actions.ON_SEARCH.success(filterList));
        }
    } catch (error) {
        log.error(error);
    }
}

export function* handleChangeForm() {
    try {
        yield put(actions.LOAD_LIST.send());
    } catch (error) {
        log.error(error);
    }
}
export default [
    ...createSagasForBasicCall(actions),
    takeLatest(actions.LOAD_LIST.sendType, loadList),
    debounce(200, actions.ON_SEARCH.sendType, searchQ),
    takeLatest(actions.ON_CHANGE_SEARCH_FORM.type, handleChangeForm),
];
